import { ReactNode } from 'react';
import { Box, Paper, SxProps, Typography } from '@mui/material';

import { normaliseSx } from '@occc-app/design-system';

type SectionCardProps = {
  title: string;
  children: ReactNode;
  headerAction?: ReactNode;
  sx?: SxProps;
  contentSx?: SxProps;
};

export const SectionCard = ({ title, children, headerAction, sx, contentSx }: SectionCardProps) => {
  return (
    <Paper elevation={2} sx={[{ overflow: 'hidden' }, ...normaliseSx(sx)]}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        gap={2}
        px={{ xs: 2, md: 3 }}
        pt={3}
      >
        <Typography variant='subtitle1' color='text.primary'>
          {title}
        </Typography>
        {headerAction}
      </Box>
      <Box
        sx={[
          {
            px: { xs: 2, md: 3 },
            pt: 3,
            pb: { xs: 2, md: 3 },
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          },
          ...normaliseSx(contentSx),
        ]}
      >
        {children}
      </Box>
    </Paper>
  );
};
